import { addClass } from 'MK/DOM/fns/classList/add'

const activeBrowser = {
  androidVersion: null,
  isAndroid: false,
  isAndroidMobile: false,
  isiOS: false,
  name: null,
  userAgent: `${window.navigator.userAgent}`,
  version: null,
  webkitVersion: null,
  detect () {
    // Parse browser flavor from user agent string
    const userAgentString = activeBrowser.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)

    if (!userAgentString) { return }

    function setBrowserVersion () {
      let userAgent = (userAgentString[2] ? [userAgentString[1], userAgentString[2]] : [window.navigator.appName, window.navigator.appVersion, '-?'])
      let version = activeBrowser.userAgent.match(/version\/(\d+)/i)
      let activeVersion = (version ? version[1] : userAgent[1])

      // Set device flags
      activeBrowser.isiOS = /iPad|iPhone|iPod/.test(activeBrowser.userAgent) && !window.MSStream
      activeBrowser.isAndroid = activeBrowser.userAgent.indexOf('Android') >= 0
      activeBrowser.isAndroidMobile = activeBrowser.userAgent.indexOf('Android') > -1 && activeBrowser.userAgent.indexOf('Mozilla/5.0') > -1 && activeBrowser.userAgent.indexOf('AppleWebKit') > -1

      // Check for Samsung Device
      if (activeBrowser.isAndroid && /Galaxy.*Tab|SAMSUNG.*Tablet|Galaxy.*Tab|SM-|Android.*GT-/i.test(activeBrowser.userAgent)) {
        activeBrowser.androidVersion = parseFloat(activeBrowser.userAgent.slice(activeBrowser.userAgent.indexOf('Android') + 8))
      }

      // Check for Apple Webkit
      if (/AppleWebKit\/([\d.]+)/.test(activeBrowser.userAgent)) {
        activeBrowser.webkitVersion = parseFloat(activeBrowser.userAgent.match(/AppleWebKit\/([\d.]+)/)[1])
      }

      // console.log('DEBUG (polyfills.browserDetection) Active browser:', { activeBrowser })

      return parseInt(activeVersion, 10)
    }

    // Set browser name & version
    activeBrowser.name = (activeBrowser.userAgent.match(/\bOPR\/(\d+)/) ? 'Opera' : userAgentString[1])
    activeBrowser.version = setBrowserVersion()
    console.log('DEBUG (polyfills.browserDetection) Active browser:', { activeBrowser })

    activeBrowser.normalize()
  },
  normalize: function () {
    if (activeBrowser.androidVersion) {
      if (activeBrowser.androidVersion >= 4.4 && activeBrowser.androidVersion <= 6) {
        // This is a Samsung Android Mobile device between version 4.4 and 6.
        // Add the special CSS class to the HTML property.
        addClass(document.documentElement, 'android-samsung-star')
      }

      activeBrowser.androidVersion <= 4.2 && MK.DOM.fns.addScript({
        async: false,
        src: 'https://static.marketreach.io/js/dom4/dom4.js'
      })
    }

    let activeUserAgent = {
      'Chrome': () => (activeBrowser.version <= 21 && activeBrowser.isiOS !== true && addClass(document.documentElement, 'chrome-legacy')),
      'Safari': () => {
        if (activeBrowser.version < 8) {
          let className
          if (activeBrowser.version <= 6 && activeBrowser.iOS !== true && activeBrowser.isAndroid !== true) {
            className = 'safari-legacy'
          } else if (activeBrowser.version <= 6 && (activeBrowser.isiOS === true || activeBrowser.isAndroidBrowser === true)) {
            className = 'ios-legacy'
          } else if (activeBrowser.version === 7 && (activeBrowser.isiOS === true || activeBrowser.isAndroidBrowser === true)) {
            className = 'ios7'
          }

          className && addClass(document.documentElement, className)

          MK.DOM.fns.addScript({
            async: false,
            src: 'https://static.marketreach.io/js/SVG4everybody/svg4everybody.legacy.js'
          })
        }
      },
      'Trident': function () {
        document.documentMode === 11 && addClass(document.documentElement, 'ie11')
      },
      'MSIE': function () {
        document.documentMode === 10 && addClass(document.documentElement, 'ie10')
      },
      'Opera': function () {
        activeBrowser.version <= 15 && MK.DOM.fns.addScript({
          async: false,
          src: 'https://static.marketreach.io/js/dom4/dom4.js'
        })

        return 'Opera'
      },
      'Firefox': function () {

        activeBrowser.version <= 28  && addClass(document.documentElement, 'firefox-legacy')
        activeBrowser.version <= 24 && MK.DOM.fns.addScript({
          async: false,
          src: 'https://static.marketreach.io/js/dom4/dom4.js'
        })
      },
      'default': () => {
        return 'Unknown'
      }
    }

    return (activeUserAgent[activeBrowser.name] || activeUserAgent['default'])()
  }
}

export const browserDetection = {
  initialize () {
    try {
      activeBrowser.detect()
    } catch (error) {
      console.log('!!! ERROR (polyfills.browserDetection) Error encountered during browser detection.')
      console.log(error)
      MK.captureException(error)
    }

    console.log('DEBUG (polyfills.browserDetection): Executed Browser Detection bundle.')
  }
}
